import type { Clock } from './clock';

export const createRealClock = (): Clock => {
    return {
        clearTimeout(id) {
            globalThis.clearTimeout(id);
        },
        getCurrentTimestamp() {
            return Date.now();
        },
        setTimeout(handler, delayInMilliseconds, ...args) {
            return globalThis.setTimeout(handler, delayInMilliseconds, ...args);
        },
    };
};
